import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        robotEnable: true,
        theme: {
            color: ''
        },
        lingkeColor: '#1EF1C6',
        // 是否是首次聊天
        is_current_service_none: false,
        // 支持的会话模式 all robot human
        isSupportHuman: 'robot',
        // 当前聊天对象 robot human
        chatTarget: 'robot',
        // 是否开启可选择技能组(入口)聊天
        skill_group: {
            enable: false,
            pop: false,
            list: [],
            group_id: ''
        },
        isInSession: true
    },
    getters: {
        robotEnable: state => state.robotEnable
    },
    mutations: {
        setRobotEnable (state, status) {
            state.robotEnable = status
        },
        setTheme (state, { theme_color }) {
            state.theme.color = theme_color
        },
        setCurrentService (state, bool) {
            state.is_current_service_none = bool
        },
        setSkillGroup (state, { key, value }) {
            state.skill_group[key] = value
        },
        setData (state, { key, value }) {
            state[key] = value
        }
    },
    actions: {
        setRobotEnable ({ commit }, status) {
            commit('setRobotEnable', status)
        }
    },
    modules: {
    }
})
